import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { useAuth } from "@/core/auth/hooks/useAuth";
import { ProtectedRoute } from "@/core/auth/guards/ProtectedRoute";
import { DashboardPage } from "@/features/dashboard/pages/DashboardPage";
import { LoginPage } from "@/features/user/pages/LoginPage";
import { LoadingSpinner } from "@/shared/components/ui/LoadingSpinner";
import { AppLayout } from "@/shared/layouts/AppLayout";
import { AuthLayout } from "@/shared/layouts/AuthLayout";

function SignedOutRoute() {
  const { user, loading } = useAuth();
  if (loading) return <LoadingSpinner fullScreen message="Loading your session..." />;
  return user ? <Navigate to="/" replace /> : <Outlet />;
}

export function AppRoutes() {
  return (
    <Routes>
      <Route element={<SignedOutRoute />}>
        <Route element={<AuthLayout />}>
          <Route path="/login" element={<LoginPage />} />
        </Route>
      </Route>
      <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
        <Route path="/" element={<DashboardPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
